import globalConfig from '@utiles/globalConfig';

const isIos = globalConfig.getHrefParam('devicePlate') == 'ios';
const pageTriggerSource = globalConfig.getHrefParam('pageTriggerSource') || '';
const isAndroid = globalConfig.getHrefParam('devicePlate') == 'android';

export const pageTriggerSourceType = {
  gameButton: 'gameButton', // 游戏内按钮
  selectPage: 'IAP' // 支付选择页
};

export const checkIsGameButton = () => {
  if (isAndroid && pageTriggerSource == pageTriggerSourceType.gameButton) {
    return true;
  }
  if (
    isIos &&
    (pageTriggerSource == pageTriggerSourceType.gameButton ||
      !pageTriggerSource)
  ) {
    return true;
  }
  return false;
};

export const checkIsSelectPage = () => {
  if (
    isAndroid &&
    (pageTriggerSource == pageTriggerSourceType.selectPage ||
      !pageTriggerSource)
  ) {
    return true;
  }
  if (isIos && pageTriggerSource == pageTriggerSourceType.selectPage) {
    return true;
  }
  return false;
};

export const getSelectPagePageType = () => {
  if (checkIsSelectPage()) {
    return 'selectPage';
  }
  if (checkIsGameButton()) {
    return 'gameButtonPage';
  }
  return '';
};

/**
 * 统一的打点辅助函数
 * @param {string} eventName - 事件名称
 * @param {object} extraData - 额外数据
 * @param {string} pageType - 页面类型
 */
export const trackStagePoint = (eventName, extraData = {}, pageType = '') => {
  window.sdkstoreDataLayer.push({
    eventName,
    eventType: extraData?.eventType || 'select_stage',
    ...(extraData.eventReason && { eventReason: extraData.eventReason }),
    eventValue: {
      timestamp: Date.now(),
      triggerSource: pageType || getSelectPagePageType(),
      ...Object.keys(extraData).reduce((acc, key) => {
        if (key !== 'eventType' && key !== 'eventReason') {
          acc[key] = extraData[key];
        }
        return acc;
      }, {})
    }
  });
};
